import { InputText } from "primereact/inputtext";
import styles from "./index.module.scss";
import { InputProps } from "./input.interface";

export const InputSearchIcon = ({
  label,
  type,
  onChange,
  // setValue,
  value,
  size,
  className,
  name,
  placeholder,
  maxLength,
  onBlur,
  tabIndex,
  autoFocus,
  onKeyDown,
  touched,
  isError,
  errorMessage,
  required,
  searchIcon,
  resetSearch
}: InputProps) => {
  return (
    <div className={`${styles.inputBox} ${className}`}>
      {label ? (
        <label htmlFor={label}>
          {label}
          {required ? <span className={styles.reqText}>*</span> : ""}
        </label>
      ) : (
        ""
      )}

      {/* <div className='p-input-icon-left'> */}
      <InputText
        maxLength={maxLength}
        className={[styles[`${type}`], styles[`${size}`]].join(" ")}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        name={name}
        tabIndex={tabIndex ?? 1}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
      />
      {searchIcon &&
        (value?.length > 0 ? (
          <i className="pi pi-times-circle" onClick={resetSearch}></i>
        ) : (
          <>
            <img src="/images/search.svg" alt="search" />
          </>
        ))}

      {/* </div> */}
      {touched && isError && <p className={styles.errorMsg}>{errorMessage}</p>}
    </div>
  );
};

export default InputSearchIcon;
